import { EMPTY_STRING } from '../../../constants/common'
import { toURLSearchParams } from '../../../utils/api'

export function getAdditionalFiltersQuery(values) {
  if (!values) {
    return EMPTY_STRING
  }

  const params = toURLSearchParams(values)

  const paramsString = params.toString()

  return paramsString ? `&${paramsString}` : EMPTY_STRING
}
